import { Button, Checkbox, FormControlLabel, Grid, Typography, Paper, Card, CardContent, Box, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { getData2 } from './features/slices';

const UploadImage = () => {
    const dispatch = useDispatch();
    const [imageData, setImageData] = useState([]);
    const [type, setType] = useState(false);
    const [bucket, setBucket] = useState('egead');
    const data = useSelector((state) => state.user.data2);
    const handleClick = async () => {
        await dispatch(getData2({
            urls: imageData,
            type: type ? "png" : "",
            bucket: bucket.trim(),
        }));

    };
    const handleChange = (event) => {
        setType(event.target.checked);
    };

    // const onDrop = (acceptedFiles) => {
    //     const reader = new FileReader();

    //     reader.onload = (event) => {
    //         const base64String = btoa(event.target.result);
    //         setImageData((prevData) => [...prevData, base64String]);
    //     };

    //     acceptedFiles.forEach((file) => reader.readAsBinaryString(file));
    // };
    const onDrop = (acceptedFiles) => {
        setImageData([])
        acceptedFiles.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const base64String = btoa(event.target.result);
                setImageData((prevData) => [...prevData, base64String]);
            };

            reader.readAsBinaryString(file);
        });
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <Box sx={{ width: '100%' }}>
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                    Upload Images
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={type}
                                onChange={handleChange}
                                name="png"
                            />
                        }
                        label="Convert to PNG format"
                    />
                </Box>
                <TextField
                    label="Spaces Bucket name"
                    fullWidth
                    value={bucket}
                    onChange={(e) => setBucket(e.target.value)}
                    placeholder="Nhập tên bucket"
                    size="small"
                    sx={{ mb: 2 }}
                />
                <Box
                    {...getRootProps()}
                    sx={{
                        border: '2px dashed #1976d2',
                        borderRadius: 2,
                        p: 4,
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: '#f8f9fa',
                        transition: 'all 0.3s',
                        '&:hover': {
                            backgroundColor: '#e3f2fd',
                            borderColor: '#1565c0'
                        }
                    }}
                >
                    <input {...getInputProps()} />
                    <Typography variant="h6" sx={{ color: '#1976d2', mb: 1 }}>
                        📁 Kéo và thả hình ảnh vào đây
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                        hoặc nhấn để chọn file
                    </Typography>
                </Box>
            </Paper>

            {imageData.length > 0 && (
                <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                        Hình ảnh đã upload ({imageData.length})
                    </Typography>
                    <Grid container spacing={2}>
                        {imageData.map((data, index) => (
                            <Grid item key={index}>
                                <Card sx={{ maxWidth: 120 }}>
                                    <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
                                        <img
                                            src={`data:image/png;base64,${data}`}
                                            alt={`Uploaded ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                borderRadius: 4
                                            }}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            )}

            {data?.length > 0 && (
                <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                        Kết quả đã convert
                    </Typography>
                    <Card sx={{ backgroundColor: '#f8f9fa' }}>
                        <CardContent>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontFamily: 'monospace',
                                    fontSize: '0.875rem',
                                    wordBreak: 'break-all',
                                    whiteSpace: 'pre-wrap'
                                }}
                            >
                                {data.join(",")}
                            </Typography>
                        </CardContent>
                    </Card>
                </Paper>
            )}

            <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClick}
                    size="large"
                    fullWidth
                    sx={{ py: 1.5 }}
                    disabled={imageData.length === 0}
                >
                    Xuất ArrayBuffer
                </Button>
            </Paper>
        </Box>
    );
};


export default UploadImage;
